import cx from 'classnames';

import Render from 'components/render';
import { LOCALES } from 'constants/dateTime';
import { CURRENCY_TYPE } from 'constants/enums';
import { formatFiat } from 'helpers/currency';
import {
  addZeroesUntilCorrectPrecision,
  convertFromUSDtoINR,
  cropAfterDecimals,
} from 'helpers/utils';
import useWalletIndianExchange from 'hooks/componentHooks/useWalletIndianExchange';
import i18n from 'i18n/config';
import { selectedProductBalance } from 'selectors/placeOrderSelector';
import { enableWalletsSelector } from 'selectors/walletSelector';
import { useAppSelector } from 'storeHooks';

import styles from './indianWallet.module.scss';

const availableForTradingLabel = i18n.t('headerFooter:header.wallet.availableBalance');

const AvailableForTrading = ({ showAmount }: { showAmount: boolean }) => {
  const { balance } = useAppSelector(selectedProductBalance);
  const balances = useAppSelector(enableWalletsSelector);
  const usdAssetMinPrecision = balances?.usd?.asset?.minimum_precision ?? 2;

  const { inrConversionRate } = useWalletIndianExchange();

  const balanceInInr = formatFiat(
    CURRENCY_TYPE.INR,
    cropAfterDecimals(
      addZeroesUntilCorrectPrecision(
        convertFromUSDtoINR(Number(balance), inrConversionRate),
        usdAssetMinPrecision
      ),
      usdAssetMinPrecision
    ),
    LOCALES.INDIA
  );

  const balanceInUsd = formatFiat(
    CURRENCY_TYPE.USD,
    cropAfterDecimals(
      addZeroesUntilCorrectPrecision(Number(balance), usdAssetMinPrecision),
      usdAssetMinPrecision
    )
  );

  return (
    (<div
      className={cx(
        styles['label-value-container'],
        styles.accountValueCollapsableButton
      )}
      data-palette="AvailableForTrading">
      <div className={styles.label}>{availableForTradingLabel}</div>
      <div className={cx('flex-set flex--column', styles.value)}>
        <span className={styles.inr}>
          <Render when={showAmount} else="******">
            {balanceInInr}
          </Render>
        </span>
        <span className={styles.usd}>
          <Render when={showAmount} else="******">
            {balanceInUsd}
          </Render>
        </span>
      </div>
    </div>)
  );
};

export default AvailableForTrading;
